import { render, staticRenderFns } from "./VisualizarInspecciones.vue?vue&type=template&id=01c58fdd"
import script from "./VisualizarInspecciones.vue?vue&type=script&lang=js"
export * from "./VisualizarInspecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports